/**
 * GENERATED from the reviewed LinuC, Server, and CS split artifacts.
 *
 * Old lesson keys remain the one enumerable static-asset identity. New owner
 * keys are one-hop lookup aliases to the same records. Do not edit by hand.
 */

export type LinucServerCsCourseSplitFamily = "linuc" | "server" | "cs";

export type LinucServerCsCourseSplitLessonAlias = Readonly<{
  family: LinucServerCsCourseSplitFamily;
  lessonId: string;
  oldKey: string;
  newKey: string;
  oldCourseSlug: "linuc-l1" | "server-basics" | "cs-algorithms";
  newCourseSlug:
    | "linuc-l1-102"
    | "linuc-l1-mock"
    | "server-operations"
    | "cs-os"
    | "cs-network"
    | "cs-database";
  lessonSlug: string;
}>;

export const LINUC_SERVER_CS_STATIC_ALIAS_COUNT = 145 as const;
export const LINUC_SERVER_CS_STATIC_ALIAS_FINGERPRINT =
  "2ad6cf019719fb3a21a077e84fc646ec375c98af89deb61ad59a37ac5e4cd08d" as const;

export const LINUC_SERVER_CS_SOURCE_MANIFEST_SHA256 = Object.freeze({
  "content/curriculum-restructures/linuc-v1/manifest.reviewed.json":
    "76cc973a31930df157634be740abf67eef0f0cd1111e89a1725c4cb0fb78fb7b",
  "content/curriculum-restructures/server-v1/manifest.reviewed.json":
    "942b76b1746788363975496bdb7167aa569d49617c683c5a423087b0d6a44452",
  "content/curriculum-restructures/cs-v1/manifest.json":
    "1d9f7ee0e5d47f213c74dd890f71e27e4bcc9fae3a4e2b2e70a0f1788b63e422",
}) satisfies Readonly<Record<string, string>>;

export const LINUC_SERVER_CS_SOURCE_MANIFEST_FINGERPRINT =
  "7051114f9ab8a9b715effcedb334cac81dfbd0f3f2bd596c4a702ee7325a2536" as const;

export const LINUC_SERVER_CS_SPLIT_DEFINITION_SHA256 = Object.freeze({
  "content/curriculum-restructures/linuc-v1/split-definition.reviewed.json":
    "c1404a62d658c551c966e445a8c5d08f5cee360e7f78157a68a1132f27259447",
  "content/curriculum-restructures/server-v1/split-definition.reviewed.json":
    "7c2ab97cd05a44fe602d24b1c4e335cba38eea87d3f1b852f2038fe717c45542",
  "content/curriculum-restructures/cs-v1/split-definition.reviewed.json":
    "e392376c5094cc81698ba8d6b74a21942463b07afb697bbc0dd66652cdb625ec",
}) satisfies Readonly<Record<string, string>>;

export const LINUC_SERVER_CS_COURSE_TITLES = Object.freeze({
  "linuc-l1": "LinuC レベル1 101試験対策（LPIC-1対応）",
  "linuc-l1-102": "LinuC レベル1 102試験対策（LPIC-1対応）",
  "linuc-l1-mock": "LinuC レベル1 模試・直前対策（LPIC-1対応）",
  "server-basics": "Webサーバー構築入門：nginx・systemd",
  "server-operations": "サーバー運用実践：セキュリティ・監視・デプロイ",
  "cs-algorithms": "アルゴリズム基礎：再帰・探索・ソート・動的計画法",
  "cs-os": "OS入門：プロセス・メモリ・ファイルシステム",
  "cs-network": "ネットワーク基礎：TCP/IP・HTTP・DNS・CDN",
  "cs-database": "データベース内部構造：インデックス・トランザクション・分散DB",
  "cs-system-design": "データ構造とアルゴリズム応用：木・グラフ・高度なDP",
}) satisfies Readonly<Record<string, string>>;

export const LINUC_SERVER_CS_FIGURE_CONTRACT = Object.freeze({
  totalLessonsByCourse: Object.freeze({
    "linuc-l1": 31,
    "linuc-l1-102": 25,
    "linuc-l1-mock": 6,
    "server-basics": 21,
    "server-operations": 30,
    "cs-algorithms": 51,
    "cs-os": 25,
    "cs-network": 29,
    "cs-database": 30,
    "cs-system-design": 50,
  }),
  figureLessonsByCourse: Object.freeze({
    "linuc-l1": 0,
    "linuc-l1-102": 0,
    "linuc-l1-mock": 0,
    "server-basics": 15,
    "server-operations": 20,
    "cs-algorithms": 44,
    "cs-os": 25,
    "cs-network": 29,
    "cs-database": 30,
    "cs-system-design": 43,
  }),
  csActiveDecks: 38,
  csSystemDesignMetadataOnly: true,
  csSystemDesignActiveDecks: 0,
  unregisteredOsDecks: 6,
  unregisteredOsDecksActive: false,
} as const);

export const LINUC_SERVER_CS_LESSON_ALIASES = Object.freeze([
  {
    family: "linuc",
    lessonId: "bcfd2377-e675-494d-a291-13ecfe341f32",
    oldKey: "linuc-l1/linuc-shell-env-exam",
    newKey: "linuc-l1-102/linuc-shell-env-exam",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-shell-env-exam",
  },
  {
    family: "linuc",
    lessonId: "4d2f1e8f-549d-447a-9cf6-88d2f5b7b85e",
    oldKey: "linuc-l1/linuc-script-test",
    newKey: "linuc-l1-102/linuc-script-test",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-script-test",
  },
  {
    family: "linuc",
    lessonId: "f1b04516-b593-41e5-9823-9b0bceebdb6b",
    oldKey: "linuc-l1/linuc-script-loops-exam",
    newKey: "linuc-l1-102/linuc-script-loops-exam",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-script-loops-exam",
  },
  {
    family: "linuc",
    lessonId: "3de65351-09c1-45f5-a260-2910443ed74b",
    oldKey: "linuc-l1/linuc-cron-at-exam",
    newKey: "linuc-l1-102/linuc-cron-at-exam",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-cron-at-exam",
  },
  {
    family: "linuc",
    lessonId: "4449a34c-451d-4fac-b198-c8edebdec75b",
    oldKey: "linuc-l1/linuc-systemd-timers",
    newKey: "linuc-l1-102/linuc-systemd-timers",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-systemd-timers",
  },
  {
    family: "linuc",
    lessonId: "f908c6e9-7367-4cdf-8199-88a45f58c5b7",
    oldKey: "linuc-l1/linuc-ch6-kakomon",
    newKey: "linuc-l1-102/linuc-ch6-kakomon",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-ch6-kakomon",
  },
  {
    family: "linuc",
    lessonId: "073da2bf-db9b-4655-8c34-38b0f7a35b9f",
    oldKey: "linuc-l1/linuc-passwd-shadow",
    newKey: "linuc-l1-102/linuc-passwd-shadow",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-passwd-shadow",
  },
  {
    family: "linuc",
    lessonId: "ac71369a-1d18-4ffd-a3c9-c806d2796e23",
    oldKey: "linuc-l1/linuc-useradd-usermod",
    newKey: "linuc-l1-102/linuc-useradd-usermod",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-useradd-usermod",
  },
  {
    family: "linuc",
    lessonId: "0510d108-7413-4c51-8ffb-8f872a3eb15f",
    oldKey: "linuc-l1/linuc-su-sudo-exam",
    newKey: "linuc-l1-102/linuc-su-sudo-exam",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-su-sudo-exam",
  },
  {
    family: "linuc",
    lessonId: "870f2449-3bab-4291-8183-5b947a36d6e8",
    oldKey: "linuc-l1/linuc-suid-sgid-sticky",
    newKey: "linuc-l1-102/linuc-suid-sgid-sticky",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-suid-sgid-sticky",
  },
  {
    family: "linuc",
    lessonId: "0838546e-e0c2-4122-9560-c6f6e7b2852e",
    oldKey: "linuc-l1/linuc-host-security-exam",
    newKey: "linuc-l1-102/linuc-host-security-exam",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-host-security-exam",
  },
  {
    family: "linuc",
    lessonId: "5b610a4a-3649-4658-a8b8-81546a7054b8",
    oldKey: "linuc-l1/linuc-ssh-gpg-exam",
    newKey: "linuc-l1-102/linuc-ssh-gpg-exam",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-ssh-gpg-exam",
  },
  {
    family: "linuc",
    lessonId: "46271d9e-3f9b-4900-b470-515b48884895",
    oldKey: "linuc-l1/linuc-ch7-kakomon",
    newKey: "linuc-l1-102/linuc-ch7-kakomon",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-ch7-kakomon",
  },
  {
    family: "linuc",
    lessonId: "4512fdca-700f-47e3-a847-e9f8ebc42454",
    oldKey: "linuc-l1/linuc-tcpip-ports",
    newKey: "linuc-l1-102/linuc-tcpip-ports",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-tcpip-ports",
  },
  {
    family: "linuc",
    lessonId: "8b306af0-a47f-43ed-8c44-1bbd0fafeb1e",
    oldKey: "linuc-l1/linuc-ip-config-exam",
    newKey: "linuc-l1-102/linuc-ip-config-exam",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-ip-config-exam",
  },
  {
    family: "linuc",
    lessonId: "dd938d50-f88a-4e4c-9c5b-6cb39ca38900",
    oldKey: "linuc-l1/linuc-routing-exam",
    newKey: "linuc-l1-102/linuc-routing-exam",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-routing-exam",
  },
  {
    family: "linuc",
    lessonId: "6b702a51-903f-4436-85fb-7e176c448361",
    oldKey: "linuc-l1/linuc-dns-client",
    newKey: "linuc-l1-102/linuc-dns-client",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-dns-client",
  },
  {
    family: "linuc",
    lessonId: "e0603426-6fa6-48f8-b1cb-9ce5d38d7b2b",
    oldKey: "linuc-l1/linuc-net-troubleshoot",
    newKey: "linuc-l1-102/linuc-net-troubleshoot",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-net-troubleshoot",
  },
  {
    family: "linuc",
    lessonId: "aa7d6986-65cc-4cda-b61c-d18bb860905c",
    oldKey: "linuc-l1/linuc-ch8-kakomon",
    newKey: "linuc-l1-102/linuc-ch8-kakomon",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-ch8-kakomon",
  },
  {
    family: "linuc",
    lessonId: "6a9b7c6d-c70a-4591-8679-eee4dbbea41a",
    oldKey: "linuc-l1/linuc-time-ntp",
    newKey: "linuc-l1-102/linuc-time-ntp",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-time-ntp",
  },
  {
    family: "linuc",
    lessonId: "bb584932-fbe4-4b6d-9bb9-3c6125232ee9",
    oldKey: "linuc-l1/linuc-locale-i18n",
    newKey: "linuc-l1-102/linuc-locale-i18n",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-locale-i18n",
  },
  {
    family: "linuc",
    lessonId: "7fef1206-bda6-4e04-8ceb-e18741620b21",
    oldKey: "linuc-l1/linuc-logging-exam",
    newKey: "linuc-l1-102/linuc-logging-exam",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-logging-exam",
  },
  {
    family: "linuc",
    lessonId: "6873c099-7351-4c44-85ba-0827a00a4827",
    oldKey: "linuc-l1/linuc-systemd-services-exam",
    newKey: "linuc-l1-102/linuc-systemd-services-exam",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-systemd-services-exam",
  },
  {
    family: "linuc",
    lessonId: "bdcc561b-d6db-4cfc-8937-efb253171b4e",
    oldKey: "linuc-l1/linuc-mail-print",
    newKey: "linuc-l1-102/linuc-mail-print",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-mail-print",
  },
  {
    family: "linuc",
    lessonId: "901b9515-39b7-4dce-9a45-ffcdd3706394",
    oldKey: "linuc-l1/linuc-ch9-kakomon",
    newKey: "linuc-l1-102/linuc-ch9-kakomon",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-102",
    lessonSlug: "linuc-ch9-kakomon",
  },
  {
    family: "linuc",
    lessonId: "19a845fd-273a-41ad-91b2-e5368b9bb482",
    oldKey: "linuc-l1/linuc-mock-101",
    newKey: "linuc-l1-mock/linuc-mock-101",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-mock",
    lessonSlug: "linuc-mock-101",
  },
  {
    family: "linuc",
    lessonId: "7f557952-437b-4896-9935-dcccf9b4e586",
    oldKey: "linuc-l1/linuc-review-101",
    newKey: "linuc-l1-mock/linuc-review-101",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-mock",
    lessonSlug: "linuc-review-101",
  },
  {
    family: "linuc",
    lessonId: "0cce3d62-449d-4e34-8e1c-094f69c12939",
    oldKey: "linuc-l1/linuc-mock-102",
    newKey: "linuc-l1-mock/linuc-mock-102",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-mock",
    lessonSlug: "linuc-mock-102",
  },
  {
    family: "linuc",
    lessonId: "bb6acb4d-aa48-4bfc-a01c-5dd53d08ec9a",
    oldKey: "linuc-l1/linuc-review-102",
    newKey: "linuc-l1-mock/linuc-review-102",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-mock",
    lessonSlug: "linuc-review-102",
  },
  {
    family: "linuc",
    lessonId: "7bc67753-f148-4b5b-8337-1ac3d4addf38",
    oldKey: "linuc-l1/linuc-last-check",
    newKey: "linuc-l1-mock/linuc-last-check",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-mock",
    lessonSlug: "linuc-last-check",
  },
  {
    family: "linuc",
    lessonId: "e41ea674-2fa2-4ecc-85fd-bf209372a2a0",
    oldKey: "linuc-l1/linuc-final-next",
    newKey: "linuc-l1-mock/linuc-final-next",
    oldCourseSlug: "linuc-l1",
    newCourseSlug: "linuc-l1-mock",
    lessonSlug: "linuc-final-next",
  },
  {
    family: "server",
    lessonId: "3af2a358-d029-470d-aa19-4f8ea4e85140",
    oldKey: "server-basics/dedicated-user",
    newKey: "server-operations/dedicated-user",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "dedicated-user",
  },
  {
    family: "server",
    lessonId: "95bcb18a-92b2-4f93-aeef-d88d5e36cfa1",
    oldKey: "server-basics/ssh-keys",
    newKey: "server-operations/ssh-keys",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "ssh-keys",
  },
  {
    family: "server",
    lessonId: "dc98148b-86e0-4667-8cae-383db62a1287",
    oldKey: "server-basics/sshd-config",
    newKey: "server-operations/sshd-config",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "sshd-config",
  },
  {
    family: "server",
    lessonId: "3c106312-2e94-4bab-8c41-cf0874e76198",
    oldKey: "server-basics/ufw",
    newKey: "server-operations/ufw",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "ufw",
  },
  {
    family: "server",
    lessonId: "f5010ab6-718c-497e-b549-36a6b152fe03",
    oldKey: "server-basics/ports-audit",
    newKey: "server-operations/ports-audit",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "ports-audit",
  },
  {
    family: "server",
    lessonId: "e3546a05-de77-486e-b3f0-662258c4fa33",
    oldKey: "server-basics/ch4-mission",
    newKey: "server-operations/ch4-mission",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "ch4-mission",
  },
  {
    family: "server",
    lessonId: "1d690d21-8c61-4e9f-9566-b89ddb7604e8",
    oldKey: "server-basics/ch4-quiz",
    newKey: "server-operations/ch4-quiz",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "ch4-quiz",
  },
  {
    family: "server",
    lessonId: "61b3ce1e-b30c-40b2-afe0-7d1e501f6416",
    oldKey: "server-basics/tls-basics",
    newKey: "server-operations/tls-basics",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "tls-basics",
  },
  {
    family: "server",
    lessonId: "50d1d338-9800-41e1-99b8-78a0a30f4473",
    oldKey: "server-basics/self-signed",
    newKey: "server-operations/self-signed",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "self-signed",
  },
  {
    family: "server",
    lessonId: "cbb39f0b-4fcc-4d91-816b-b14da5ef1c0e",
    oldKey: "server-basics/nginx-https",
    newKey: "server-operations/nginx-https",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "nginx-https",
  },
  {
    family: "server",
    lessonId: "bb0c6ca7-cf5b-46d5-828a-3d7705cb7291",
    oldKey: "server-basics/http-redirect",
    newKey: "server-operations/http-redirect",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "http-redirect",
  },
  {
    family: "server",
    lessonId: "8c57c6d5-f329-43a1-b0d1-e202e061e0ef",
    oldKey: "server-basics/ch5-mission",
    newKey: "server-operations/ch5-mission",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "ch5-mission",
  },
  {
    family: "server",
    lessonId: "87dbfa3e-a0d1-458f-8b8e-483076ff6301",
    oldKey: "server-basics/ch5-quiz",
    newKey: "server-operations/ch5-quiz",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "ch5-quiz",
  },
  {
    family: "server",
    lessonId: "0d3e8066-5107-4eaa-8623-1749fda10187",
    oldKey: "server-basics/tmux",
    newKey: "server-operations/tmux",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "tmux",
  },
  {
    family: "server",
    lessonId: "686c5a36-627b-457b-b473-ba3ff13a528b",
    oldKey: "server-basics/logrotate",
    newKey: "server-operations/logrotate",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "logrotate",
  },
  {
    family: "server",
    lessonId: "7d9a4abe-9697-4e9f-a62c-b56f9ab71497",
    oldKey: "server-basics/error-log",
    newKey: "server-operations/error-log",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "error-log",
  },
  {
    family: "server",
    lessonId: "9410081b-ef32-4d14-b4a9-f44093d8f029",
    oldKey: "server-basics/healthcheck",
    newKey: "server-operations/healthcheck",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "healthcheck",
  },
  {
    family: "server",
    lessonId: "b404ca95-a26e-4793-91f1-e237d3db0857",
    oldKey: "server-basics/systemd-timer",
    newKey: "server-operations/systemd-timer",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "systemd-timer",
  },
  {
    family: "server",
    lessonId: "a7df7cc2-8da5-46a2-86e4-35111b905e80",
    oldKey: "server-basics/ch6-mission",
    newKey: "server-operations/ch6-mission",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "ch6-mission",
  },
  {
    family: "server",
    lessonId: "e26a78e4-3584-44f5-87f5-8188f838a738",
    oldKey: "server-basics/ch6-quiz",
    newKey: "server-operations/ch6-quiz",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "ch6-quiz",
  },
  {
    family: "server",
    lessonId: "9e148433-d32c-46f9-8fd4-14b1f5ea2b2d",
    oldKey: "server-basics/deploy-pattern",
    newKey: "server-operations/deploy-pattern",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "deploy-pattern",
  },
  {
    family: "server",
    lessonId: "d5b9d11c-44eb-4c0e-a5bb-22251223e170",
    oldKey: "server-basics/symlink",
    newKey: "server-operations/symlink",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "symlink",
  },
  {
    family: "server",
    lessonId: "474af898-4373-424d-9583-f837fafcc4aa",
    oldKey: "server-basics/deploy-v2",
    newKey: "server-operations/deploy-v2",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "deploy-v2",
  },
  {
    family: "server",
    lessonId: "3995174e-934e-48ef-acd7-78718da1731f",
    oldKey: "server-basics/rollback",
    newKey: "server-operations/rollback",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "rollback",
  },
  {
    family: "server",
    lessonId: "5832e9f1-f80a-4bd8-8ffc-66d21dbde855",
    oldKey: "server-basics/ch7-mission",
    newKey: "server-operations/ch7-mission",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "ch7-mission",
  },
  {
    family: "server",
    lessonId: "3a2b156e-5083-4a47-bd85-9020a41d8c81",
    oldKey: "server-basics/ch7-quiz",
    newKey: "server-operations/ch7-quiz",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "ch7-quiz",
  },
  {
    family: "server",
    lessonId: "a16d6319-885e-49cb-a846-75ede2c1bcc1",
    oldKey: "server-basics/final-rebuild",
    newKey: "server-operations/final-rebuild",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "final-rebuild",
  },
  {
    family: "server",
    lessonId: "8656147f-deb2-4f65-8f05-c5fe53dbdcbe",
    oldKey: "server-basics/final-incident",
    newKey: "server-operations/final-incident",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "final-incident",
  },
  {
    family: "server",
    lessonId: "24431c8d-8156-462a-84f4-86c399cea499",
    oldKey: "server-basics/final-extend",
    newKey: "server-operations/final-extend",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "final-extend",
  },
  {
    family: "server",
    lessonId: "a44b7b9f-26db-441f-8239-fb23b9635eb8",
    oldKey: "server-basics/final-next",
    newKey: "server-operations/final-next",
    oldCourseSlug: "server-basics",
    newCourseSlug: "server-operations",
    lessonSlug: "final-next",
  },
  {
    family: "cs",
    lessonId: "40506822-83a5-46e0-beef-35a8b8b0d50f",
    oldKey: "cs-algorithms/os-what-is",
    newKey: "cs-os/os-what-is",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-what-is",
  },
  {
    family: "cs",
    lessonId: "76294343-2d82-415b-8d6c-05c73fdb6eeb",
    oldKey: "cs-algorithms/os-history",
    newKey: "cs-os/os-history",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-history",
  },
  {
    family: "cs",
    lessonId: "79fa4886-87be-456f-a078-992da910c948",
    oldKey: "cs-algorithms/os-kernel-userland",
    newKey: "cs-os/os-kernel-userland",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-kernel-userland",
  },
  {
    family: "cs",
    lessonId: "1e315126-d41a-4e37-8c1d-f50f012a0ea9",
    oldKey: "cs-algorithms/os-system-call",
    newKey: "cs-os/os-system-call",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-system-call",
  },
  {
    family: "cs",
    lessonId: "923bedde-d35f-4636-99b6-05210e93b6c3",
    oldKey: "cs-algorithms/os-popular-os",
    newKey: "cs-os/os-popular-os",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-popular-os",
  },
  {
    family: "cs",
    lessonId: "8b2d6f57-bce7-4b14-8694-d89efbb9d0be",
    oldKey: "cs-algorithms/os-process",
    newKey: "cs-os/os-process",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-process",
  },
  {
    family: "cs",
    lessonId: "88ce4dd8-3f94-44b9-be69-0ea7ec4855da",
    oldKey: "cs-algorithms/os-thread",
    newKey: "cs-os/os-thread",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-thread",
  },
  {
    family: "cs",
    lessonId: "14f1e2f2-e312-4a1a-87be-a4ccb3242394",
    oldKey: "cs-algorithms/os-context-switch",
    newKey: "cs-os/os-context-switch",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-context-switch",
  },
  {
    family: "cs",
    lessonId: "63839d58-c416-43d9-a103-9048ffd9b511",
    oldKey: "cs-algorithms/os-scheduler",
    newKey: "cs-os/os-scheduler",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-scheduler",
  },
  {
    family: "cs",
    lessonId: "6b5ff491-04b0-4300-9e6e-803e2be976a0",
    oldKey: "cs-algorithms/os-ipc",
    newKey: "cs-os/os-ipc",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-ipc",
  },
  {
    family: "cs",
    lessonId: "28258337-0948-4878-a429-5daa065b0844",
    oldKey: "cs-algorithms/os-memory-hierarchy",
    newKey: "cs-os/os-memory-hierarchy",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-memory-hierarchy",
  },
  {
    family: "cs",
    lessonId: "b890b508-4801-4911-9b5a-c5ba40244fa7",
    oldKey: "cs-algorithms/os-virtual-memory",
    newKey: "cs-os/os-virtual-memory",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-virtual-memory",
  },
  {
    family: "cs",
    lessonId: "7ab8e99a-2aee-4d6f-b650-adc9cb298648",
    oldKey: "cs-algorithms/os-paging",
    newKey: "cs-os/os-paging",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-paging",
  },
  {
    family: "cs",
    lessonId: "b116ea28-2ebe-4d2e-a97c-ccbd2479d412",
    oldKey: "cs-algorithms/os-mmap",
    newKey: "cs-os/os-mmap",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-mmap",
  },
  {
    family: "cs",
    lessonId: "e7f778a6-c54e-4b26-a969-2991b57779f7",
    oldKey: "cs-algorithms/os-gc",
    newKey: "cs-os/os-gc",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-gc",
  },
  {
    family: "cs",
    lessonId: "46dfc133-fe43-4420-ab33-a14ca499ac23",
    oldKey: "cs-algorithms/os-filesystem",
    newKey: "cs-os/os-filesystem",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-filesystem",
  },
  {
    family: "cs",
    lessonId: "3178f4d1-282e-4a97-b88a-f3180c0d0f6b",
    oldKey: "cs-algorithms/os-inode",
    newKey: "cs-os/os-inode",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-inode",
  },
  {
    family: "cs",
    lessonId: "18b97457-93fe-450c-92b3-f3eda0817ddb",
    oldKey: "cs-algorithms/os-fs-types",
    newKey: "cs-os/os-fs-types",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-fs-types",
  },
  {
    family: "cs",
    lessonId: "aa79674d-afa2-4a33-a8b7-73527c4be886",
    oldKey: "cs-algorithms/os-journaling",
    newKey: "cs-os/os-journaling",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-journaling",
  },
  {
    family: "cs",
    lessonId: "66881e32-9cc8-4a0e-a394-35a015b8f02b",
    oldKey: "cs-algorithms/os-permissions",
    newKey: "cs-os/os-permissions",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-permissions",
  },
  {
    family: "cs",
    lessonId: "f6edb1cd-41dc-4db4-b23a-5312798b8f7f",
    oldKey: "cs-algorithms/os-race-condition",
    newKey: "cs-os/os-race-condition",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-race-condition",
  },
  {
    family: "cs",
    lessonId: "4ba7a248-7031-427a-9648-f1281828dd69",
    oldKey: "cs-algorithms/os-mutex",
    newKey: "cs-os/os-mutex",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-mutex",
  },
  {
    family: "cs",
    lessonId: "8da1d19d-55d1-40a9-ad33-4e1f1cb47b40",
    oldKey: "cs-algorithms/os-deadlock",
    newKey: "cs-os/os-deadlock",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-deadlock",
  },
  {
    family: "cs",
    lessonId: "31fb591f-3721-4930-8a6f-c9f4ec306310",
    oldKey: "cs-algorithms/os-async",
    newKey: "cs-os/os-async",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-async",
  },
  {
    family: "cs",
    lessonId: "6e6a5368-79ba-41d2-b976-4f619d0efa6f",
    oldKey: "cs-algorithms/os-io",
    newKey: "cs-os/os-io",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-os",
    lessonSlug: "os-io",
  },
  {
    family: "cs",
    lessonId: "837777df-6907-4e19-925d-57e4faf0adf3",
    oldKey: "cs-algorithms/net-what-is",
    newKey: "cs-network/net-what-is",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-what-is",
  },
  {
    family: "cs",
    lessonId: "bacc8bbd-5fbc-4d5f-b39c-26df36b973b7",
    oldKey: "cs-algorithms/net-osi-model",
    newKey: "cs-network/net-osi-model",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-osi-model",
  },
  {
    family: "cs",
    lessonId: "7561865f-bedb-4455-b874-d3cdd5c201cb",
    oldKey: "cs-algorithms/net-tcpip-model",
    newKey: "cs-network/net-tcpip-model",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-tcpip-model",
  },
  {
    family: "cs",
    lessonId: "52ce61c9-89c6-4af9-b1cd-815e9d799bde",
    oldKey: "cs-algorithms/net-packet",
    newKey: "cs-network/net-packet",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-packet",
  },
  {
    family: "cs",
    lessonId: "4468f389-7fbc-4938-8867-4aedaa030326",
    oldKey: "cs-algorithms/net-router-switch",
    newKey: "cs-network/net-router-switch",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-router-switch",
  },
  {
    family: "cs",
    lessonId: "8e93ad6d-c935-47f4-89c7-ac29a265a972",
    oldKey: "cs-algorithms/net-ip-address",
    newKey: "cs-network/net-ip-address",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-ip-address",
  },
  {
    family: "cs",
    lessonId: "b95d2953-48c3-4b37-9341-05a242a8629b",
    oldKey: "cs-algorithms/net-subnet",
    newKey: "cs-network/net-subnet",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-subnet",
  },
  {
    family: "cs",
    lessonId: "ffc39104-0e4a-4a80-bf02-1752b2c7674a",
    oldKey: "cs-algorithms/net-nat",
    newKey: "cs-network/net-nat",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-nat",
  },
  {
    family: "cs",
    lessonId: "8a945a38-d471-49db-b96d-b08df78ddaa2",
    oldKey: "cs-algorithms/net-routing",
    newKey: "cs-network/net-routing",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-routing",
  },
  {
    family: "cs",
    lessonId: "9b717541-9222-4ce3-9884-77f2ba641b45",
    oldKey: "cs-algorithms/net-firewall",
    newKey: "cs-network/net-firewall",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-firewall",
  },
  {
    family: "cs",
    lessonId: "17f91066-8b22-43e8-961c-6a90f21308cd",
    oldKey: "cs-algorithms/net-tcp-vs-udp",
    newKey: "cs-network/net-tcp-vs-udp",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-tcp-vs-udp",
  },
  {
    family: "cs",
    lessonId: "cd00c0af-024f-46a6-b32b-2590dae33037",
    oldKey: "cs-algorithms/net-tcp-handshake",
    newKey: "cs-network/net-tcp-handshake",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-tcp-handshake",
  },
  {
    family: "cs",
    lessonId: "3fca0f4f-e969-45aa-a506-a68a962a2127",
    oldKey: "cs-algorithms/net-tcp-congestion",
    newKey: "cs-network/net-tcp-congestion",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-tcp-congestion",
  },
  {
    family: "cs",
    lessonId: "4b240ea9-7dd9-4be9-b845-37ad918a6648",
    oldKey: "cs-algorithms/net-udp-use-cases",
    newKey: "cs-network/net-udp-use-cases",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-udp-use-cases",
  },
  {
    family: "cs",
    lessonId: "dd217429-9d2e-412e-ad82-a1b2fb235641",
    oldKey: "cs-algorithms/net-port",
    newKey: "cs-network/net-port",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-port",
  },
  {
    family: "cs",
    lessonId: "1799b0c6-5a54-42a1-8d3b-d596c72ff63b",
    oldKey: "cs-algorithms/net-http-intro",
    newKey: "cs-network/net-http-intro",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-http-intro",
  },
  {
    family: "cs",
    lessonId: "068f4129-dae4-4623-816c-0638a4569ed9",
    oldKey: "cs-algorithms/net-http-methods",
    newKey: "cs-network/net-http-methods",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-http-methods",
  },
  {
    family: "cs",
    lessonId: "064ca675-de50-4026-b452-a495dacda868",
    oldKey: "cs-algorithms/net-https",
    newKey: "cs-network/net-https",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-https",
  },
  {
    family: "cs",
    lessonId: "24e74abf-ead7-4681-8185-9051cc6a0fd7",
    oldKey: "cs-algorithms/net-http2-http3",
    newKey: "cs-network/net-http2-http3",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-http2-http3",
  },
  {
    family: "cs",
    lessonId: "ae165469-6a9f-4ed7-8967-27e1027309be",
    oldKey: "cs-algorithms/net-rest-api",
    newKey: "cs-network/net-rest-api",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-rest-api",
  },
  {
    family: "cs",
    lessonId: "a49f789c-3eed-482f-abc0-3962c1a16119",
    oldKey: "cs-algorithms/net-dns-intro",
    newKey: "cs-network/net-dns-intro",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-dns-intro",
  },
  {
    family: "cs",
    lessonId: "d2194382-1193-4f41-88dd-7a0e2e1360c6",
    oldKey: "cs-algorithms/net-dns-records",
    newKey: "cs-network/net-dns-records",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-dns-records",
  },
  {
    family: "cs",
    lessonId: "56441146-e1a7-4702-a19c-111ea57aba69",
    oldKey: "cs-algorithms/net-dns-resolution",
    newKey: "cs-network/net-dns-resolution",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-dns-resolution",
  },
  {
    family: "cs",
    lessonId: "1cf33bca-ed77-4b7e-aab5-32e1cdf34b37",
    oldKey: "cs-algorithms/net-dns-cache",
    newKey: "cs-network/net-dns-cache",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-dns-cache",
  },
  {
    family: "cs",
    lessonId: "549b1172-4527-43a8-9a8d-cfb4885925f9",
    oldKey: "cs-algorithms/net-cdn",
    newKey: "cs-network/net-cdn",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-cdn",
  },
  {
    family: "cs",
    lessonId: "7e1898a2-3c80-4a78-a58a-5ad6308bb123",
    oldKey: "cs-algorithms/net-load-balancer",
    newKey: "cs-network/net-load-balancer",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-load-balancer",
  },
  {
    family: "cs",
    lessonId: "e90d6f98-83db-43e8-9104-aca4081635f6",
    oldKey: "cs-algorithms/net-proxy",
    newKey: "cs-network/net-proxy",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-proxy",
  },
  {
    family: "cs",
    lessonId: "1308f919-9f26-4345-bd45-f63308521151",
    oldKey: "cs-algorithms/net-websocket",
    newKey: "cs-network/net-websocket",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-websocket",
  },
  {
    family: "cs",
    lessonId: "32b4b567-cef3-429b-aa34-c361c6421698",
    oldKey: "cs-algorithms/net-grpc",
    newKey: "cs-network/net-grpc",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-network",
    lessonSlug: "net-grpc",
  },
  {
    family: "cs",
    lessonId: "582a7c9a-3f2b-4927-b52f-9ea0813a0671",
    oldKey: "cs-algorithms/db-what-is",
    newKey: "cs-database/db-what-is",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-what-is",
  },
  {
    family: "cs",
    lessonId: "46ee1f1d-cf32-4e05-9269-08009bfbef7b",
    oldKey: "cs-algorithms/db-rdb-vs-nosql",
    newKey: "cs-database/db-rdb-vs-nosql",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-rdb-vs-nosql",
  },
  {
    family: "cs",
    lessonId: "ded2d9fb-0e74-41bd-b155-b4ac315a7f6f",
    oldKey: "cs-algorithms/db-history",
    newKey: "cs-database/db-history",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-history",
  },
  {
    family: "cs",
    lessonId: "bfe746a5-8b34-4e46-84f0-ea6ce34f831e",
    oldKey: "cs-algorithms/db-er-model",
    newKey: "cs-database/db-er-model",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-er-model",
  },
  {
    family: "cs",
    lessonId: "1fd91818-0a17-4397-a0e4-c5569430a4af",
    oldKey: "cs-algorithms/db-keys",
    newKey: "cs-database/db-keys",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-keys",
  },
  {
    family: "cs",
    lessonId: "0f1abaec-9ec6-4854-8df6-5092189dcd13",
    oldKey: "cs-algorithms/db-normalization-intro",
    newKey: "cs-database/db-normalization-intro",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-normalization-intro",
  },
  {
    family: "cs",
    lessonId: "38c71c4c-aeae-4c45-95c0-f32d69c5ac0a",
    oldKey: "cs-algorithms/db-1nf",
    newKey: "cs-database/db-1nf",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-1nf",
  },
  {
    family: "cs",
    lessonId: "450bd8ed-a768-4b9b-84c4-d64d6a1b6209",
    oldKey: "cs-algorithms/db-2nf",
    newKey: "cs-database/db-2nf",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-2nf",
  },
  {
    family: "cs",
    lessonId: "5a1f116b-acd6-4de1-a45c-980fea31b2f9",
    oldKey: "cs-algorithms/db-3nf",
    newKey: "cs-database/db-3nf",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-3nf",
  },
  {
    family: "cs",
    lessonId: "e05e75df-b0eb-44a5-ab0e-9bab3d4a47cf",
    oldKey: "cs-algorithms/db-denormalization",
    newKey: "cs-database/db-denormalization",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-denormalization",
  },
  {
    family: "cs",
    lessonId: "a6ce9849-63b0-4e2d-81f4-5dccf1f6f256",
    oldKey: "cs-algorithms/db-index-intro",
    newKey: "cs-database/db-index-intro",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-index-intro",
  },
  {
    family: "cs",
    lessonId: "c0e16709-be70-46c6-b40e-86dcc0af14bd",
    oldKey: "cs-algorithms/db-btree",
    newKey: "cs-database/db-btree",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-btree",
  },
  {
    family: "cs",
    lessonId: "f68bbe10-83b4-45c6-9f58-62dc4c527e58",
    oldKey: "cs-algorithms/db-bptree",
    newKey: "cs-database/db-bptree",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-bptree",
  },
  {
    family: "cs",
    lessonId: "4f201fae-aa77-4f09-a932-aa22b3b10a86",
    oldKey: "cs-algorithms/db-hash-index",
    newKey: "cs-database/db-hash-index",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-hash-index",
  },
  {
    family: "cs",
    lessonId: "ec7ae306-37bf-49bb-b881-760e2eb79ab2",
    oldKey: "cs-algorithms/db-covering-index",
    newKey: "cs-database/db-covering-index",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-covering-index",
  },
  {
    family: "cs",
    lessonId: "dc06829d-71c5-4447-8588-0d3b2fd6d1bb",
    oldKey: "cs-algorithms/db-transaction-intro",
    newKey: "cs-database/db-transaction-intro",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-transaction-intro",
  },
  {
    family: "cs",
    lessonId: "f7b51363-6ae0-435a-a100-532aead55ca9",
    oldKey: "cs-algorithms/db-acid",
    newKey: "cs-database/db-acid",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-acid",
  },
  {
    family: "cs",
    lessonId: "2de45715-3b53-4021-9794-8fd16fab1b01",
    oldKey: "cs-algorithms/db-isolation-levels",
    newKey: "cs-database/db-isolation-levels",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-isolation-levels",
  },
  {
    family: "cs",
    lessonId: "7281d9b5-5845-47c7-9271-c5a959e640fa",
    oldKey: "cs-algorithms/db-mvcc",
    newKey: "cs-database/db-mvcc",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-mvcc",
  },
  {
    family: "cs",
    lessonId: "3beef9c4-df92-4bb8-8a55-0b3a65b6faee",
    oldKey: "cs-algorithms/db-deadlock",
    newKey: "cs-database/db-deadlock",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-deadlock",
  },
  {
    family: "cs",
    lessonId: "f6fcbcd8-4cb6-4380-90ff-b648bc528ed6",
    oldKey: "cs-algorithms/db-query-planner",
    newKey: "cs-database/db-query-planner",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-query-planner",
  },
  {
    family: "cs",
    lessonId: "06891900-bdfe-4c79-89f5-0c25a9376a53",
    oldKey: "cs-algorithms/db-explain",
    newKey: "cs-database/db-explain",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-explain",
  },
  {
    family: "cs",
    lessonId: "1beda820-d57d-4c97-92cd-cb4763acb449",
    oldKey: "cs-algorithms/db-join-types",
    newKey: "cs-database/db-join-types",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-join-types",
  },
  {
    family: "cs",
    lessonId: "05c85be1-e8b7-4bb5-bcd0-48ff77867153",
    oldKey: "cs-algorithms/db-index-tuning",
    newKey: "cs-database/db-index-tuning",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-index-tuning",
  },
  {
    family: "cs",
    lessonId: "1cff76fd-9d4f-46aa-929a-5997d6d3e020",
    oldKey: "cs-algorithms/db-stats-cardinality",
    newKey: "cs-database/db-stats-cardinality",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-stats-cardinality",
  },
  {
    family: "cs",
    lessonId: "acc52803-6434-40e4-8012-8ce5cf6063eb",
    oldKey: "cs-algorithms/db-replication",
    newKey: "cs-database/db-replication",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-replication",
  },
  {
    family: "cs",
    lessonId: "3a9ed48d-8ff2-4cf3-9086-f9909ba4c53f",
    oldKey: "cs-algorithms/db-sharding",
    newKey: "cs-database/db-sharding",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-sharding",
  },
  {
    family: "cs",
    lessonId: "f28ad7e4-5dd6-4422-911d-f2aa049b45c6",
    oldKey: "cs-algorithms/db-cap-theorem",
    newKey: "cs-database/db-cap-theorem",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-cap-theorem",
  },
  {
    family: "cs",
    lessonId: "ede57e42-b9ba-4a7a-9d75-d8fe49c77b9f",
    oldKey: "cs-algorithms/db-eventual-consistency",
    newKey: "cs-database/db-eventual-consistency",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-eventual-consistency",
  },
  {
    family: "cs",
    lessonId: "74e9f4b4-1baf-47fb-8d94-cc73caa0d645",
    oldKey: "cs-algorithms/db-newsql",
    newKey: "cs-database/db-newsql",
    oldCourseSlug: "cs-algorithms",
    newCourseSlug: "cs-database",
    lessonSlug: "db-newsql",
  },
]) satisfies readonly LinucServerCsCourseSplitLessonAlias[];

export const LINUC_SERVER_CS_OLD_TO_NEW_LESSON_KEY: Readonly<
  Record<string, string>
> = Object.freeze(
  Object.fromEntries(
    LINUC_SERVER_CS_LESSON_ALIASES.map(({ oldKey, newKey }) => [
      oldKey,
      newKey,
    ]),
  ),
);

export const LINUC_SERVER_CS_NEW_TO_OLD_LESSON_KEY: Readonly<
  Record<string, string>
> = Object.freeze(
  Object.fromEntries(
    LINUC_SERVER_CS_LESSON_ALIASES.map(({ oldKey, newKey }) => [
      newKey,
      oldKey,
    ]),
  ),
);

if (
  Object.keys(LINUC_SERVER_CS_OLD_TO_NEW_LESSON_KEY).length !==
    LINUC_SERVER_CS_LESSON_ALIASES.length ||
  Object.keys(LINUC_SERVER_CS_NEW_TO_OLD_LESSON_KEY).length !==
    LINUC_SERVER_CS_LESSON_ALIASES.length
) {
  throw new Error("duplicate LinuC/Server/CS split static lesson key");
}
for (const newKey of Object.keys(LINUC_SERVER_CS_NEW_TO_OLD_LESSON_KEY)) {
  if (LINUC_SERVER_CS_OLD_TO_NEW_LESSON_KEY[newKey]) {
    throw new Error(
      `chained LinuC/Server/CS split static lesson key: ${newKey}`,
    );
  }
}
